import React from 'react';

export const SpanAnchorLink: React.FC<{ hash: string; text: string }> = ({ hash, text }) => {
	return (
		<span
			tabIndex={0}
			role="link"
			onClick={() => {
				const e = document.getElementById(hash);
				if (e) e.scrollIntoView({ behavior: 'smooth' });
			}}
		>
			<a>{text}</a>
		</span>
	);
};
